import {Trans, useTranslation} from 'react-i18next';
import CopyToClipboard from 'components/CopyToClipboard';
import LinkButton from 'components/LinkButton';
import NavigationTabs from 'components/Navigation/NavigationTabs';
import SectionHeader from 'components/SectionHeader';
import {H2, H3, H4} from 'components/Typography';
import {useBackend} from 'state/backend';
import {Backend} from 'types/api';

const CLOUD_BUYER_RICOH_LINK = 'https://cloud.buyer.digital.ricoh.com/';

export type RicohTradeAutomationBackendData = Backend<{
    invitationLink: string;
}>;

const RicohTradeAutomation = () => {
    const {
        data: {invitationLink},
    } = useBackend<RicohTradeAutomationBackendData>();

    const {t} = useTranslation('Partner.Integrations.RicohTradeAutomation');

    return (
        <>
            <NavigationTabs.Partner selection="integrations" />
            <SectionHeader subtitle={t('subtitle')} title={t('title')} />
            <H2>{t('forRicohTradeAutomationUsers')}</H2>
            <H3>{t('logInToRicohTradeAutomation')}</H3>
            <LinkButton
                aria-label="go-to-the-app-button"
                className="mb-2 mt-4 inline-block"
                href={CLOUD_BUYER_RICOH_LINK}
                kind="primary"
                size="sm"
                target="_blank"
            >
                {t('goButton')}
            </LinkButton>
            <H3>{t('signPageForVendors')}</H3>
            <p>{t('inviteParagraph')}</p>
            <CopyToClipboard className="my-2" size="sm" value={invitationLink}>
                {t('clickToCopy')}
            </CopyToClipboard>
            <H4>{t('listStarterPlanTitle')}</H4>
            <ul>
                <li>{t('firstListElementStarterPlan')}</li>
                <li>{t('secondListElementStarterPlan')}</li>
                <li>{t('thirdListElementStarterPlan')}</li>
            </ul>
            <hr />
            <H2>{t('titleThinkingAboutRicohTradeAutomation')}</H2>
            <p>{t('paragraphThinkingAboutRicohTradeAutomation')}</p>
            <H4>{t('listImportInvoicesTitle')}</H4>
            <ul>
                <li>{t('firstListImportInvoices')}</li>
                <li>{t('secondListImportInvoices')}</li>
                <li>{t('thirdListImportInvoices')}</li>
                <li>{t('fourthListImportInvoices')}</li>
                <li>{t('fifthListImportInvoices')}</li>
            </ul>
            <p>
                <Trans
                    components={[
                        <a
                            key={0}
                            aria-label="find-out-more-link"
                            href="https://www.ricoh.co.jp/service/trade-automation"
                            rel="noreferrer"
                            target="_blank"
                        >
                            {' '}
                        </a>,
                    ]}
                    i18nKey="findOutMoreLink"
                    t={t}
                />
            </p>
        </>
    );
};

export default RicohTradeAutomation;
